/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, isLoadingCart, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;



  /*
  *-----------------------
  *  Free Shipping
  *-----------------------
  */

  /*
  *-----------------------
  *  Black Friday Promo
  *-----------------------
  */
  
  let product_object;
  let variant_available_object;
  
  const product_handle = "50-gift-card";
  
  /*--------------------------------------------*/
  /*methods to fill let variables declared above*/
  
  $.ajax({
    url:'/products/' + product_handle + '.js',
    dataType: 'json',
    async: false,
    success: function(product){
      product_object = product;
    }
  });
     
  for(let i = 0; i < product_object.variants.length; i++){
    if(product_object.variants[i].available === true){
      variant_available_object = product_object.variants[i];
      break;
    }
  }
  
  /*-------------------------------------*/
  /*methods to add and remove avo gift*/
  
  const add_gift = function(){      
    const variant = variant_available_object;
    const var_id = variant.id;
    const item = {
      "id": var_id,
      "quantity": 1,        
      "properties":{
        "_aov_free_gift":true            
      }
    };     

    $.ajax({
      type:'POST',
      url:'/cart/add.js',
      data: item,
      dataType: 'json',
      success:function(e){
        ajaxCart.load();
      },
      error: function(e){
        console.log("error", e)
      }
    });       
  };
  
  const remove_gift = function(){
    const variant = variant_available_object;
    const var_id = variant.id;
    const item = {
      "id": var_id,
      "quantity": 0
    };     

    $.ajax({
      type:'POST',
      url:'/cart/change.js',
      data: item,
      dataType: 'json',
      success:function(e){  
        setTimeout(function() {
          ajaxCart.load();
        }, 2000);                
      },
      error: function(e){
        console.log("error", e)
      }
    });      
  };

  // Ensure <meter> UI updates reliably across browsers (iOS/Safari needs both .value and attribute + reflow)
  function setMeterValue(id, percent) {
    try {
      var v = Math.max(0, Math.min(100, Math.round(Number(percent) || 0)));
      var $m = jQuery('#' + id);
      if (!$m.length) return;
      $m.val(v);
      $m.attr('value', v);
      var el = $m[0];
      if (el) { void el.offsetWidth; }
    } catch (e) {}
  }

  const blackFridayPromo = function(cart_total, cart){
    const meter20_message = "You've unlocked <span id='current_promo'>Free Shipping!</span>";
    const meter50_message = "You've unlocked <span id='current_promo'>Free $50 Gift Card + Free Shipping!</span>";
    const meter100_message = "You've unlocked <span id='current_promo'>$100 Off + Free Shipping!</span>";
    var cartTotalvar = cart_total / 100;
    const cart_object = cart;
    
    let aov_product_added = false;
    for(let i = 0; i < cart_object.items.length; i++){
      if(cart_object.items[i].id === variant_available_object.id && JSON.stringify(cart_object.items[i].properties).indexOf("_aov_free_gift") > -1){
        aov_product_added = true;
        cartTotalvar = cartTotalvar - (cart_object.items[i].final_line_price / 100);

        break;
      }        
    }

    const cartTotal = cartTotalvar;

    $(".gwp-added").hide();    

    if(cartTotal < 125){
      const barPercent = (cartTotal * 100)/125;
      let priceLeft_raw = 125 - cartTotal;      
      let priceLeft_fixed =  priceLeft_raw.toFixed(2);

      setMeterValue('meter20', barPercent);
      console.log('bar percent set to: '+barPercent);
      if(cartTotal == 0){
        $("#progress_text").html(`Get <span id='current_promo'>Free Free Shipping</span> when you spend $125+`);
      } else {
        $("#progress_text").html(`You are just $${priceLeft_fixed} away from <span id='current_promo'>Free Shipping</span>!`);
      }

      setMeterValue('meter50', 0);
      setMeterValue('meter100', 0);
      $("#meter20, #meter50, #meter100").parent(".meter_element").removeClass("completeStep");
      
      /*if(aov_product_added){
        remove_gift();
      }*/

      $(".gwp-added").hide();

    }else if(cartTotal >= 125 && cartTotal < 175){
      const barPercent = (cartTotal * 100)/125;
      let priceLeft_raw = 125 - cartTotal;      
      let priceLeft_fixed =  priceLeft_raw.toFixed(2);

      $(".gwp-added").hide();

      if(cartTotal === 125){
        $("#progress_text").html(meter20_message);
      }else{
        setMeterValue('meter50', barPercent);
        $("#progress_text").html(meter20_message);
        /*$("#progress_text").html(`You are just $${priceLeft_fixed} away from a <span id='current_promo'>$50 Gift Card</span>!`);*/
      }

      setMeterValue('meter20', 100);
      $("#meter20").parent(".meter_element").addClass("completeStep");

      $("#meter50").parent(".meter_element").removeClass("completeStep");

      /*if(aov_product_added){
        remove_gift();
      }*/

    }else if(cartTotal >= 175){
      const barPercent = (cartTotal * 100)/125;
      let priceLeft_raw = 125 - cartTotal;
      let priceLeft_fixed =  priceLeft_raw.toFixed(2);

      $("#progress_text").html(meter20_message);
      setMeterValue('meter20', 100);
      setMeterValue('meter50', 100);
      $("#meter20, #meter50").parent(".meter_element").addClass("completeStep");

      /*if(aov_product_added === false){
        
        add_gift();          
        
      } */     

      /*$(".gwp-added").show();*/

    }
  };

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : '[data-header-cart-count]',
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;
    isLoadingCart = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    // Prevent overlapping loads that cause double renders
    if (isLoadingCart) { return; }
    isLoadingCart = true;
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.attr('data-header-cart-count', cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();
      
      $(evt.target).addClass('adding-to-cart');

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    $formContainer.removeClass('adding-to-cart');

    // Centralize cart refresh through loadCart to debounce duplicate loads
    loadCart();
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    
    var pageHasCollectionGrid = $('#product-loop').length || $('.collection-carousel').length;
    if (pageHasCollectionGrid) {
      $formContainer = $('form.adding-to-cart');
    }

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>');
        $formContainer.removeClass('adding-to-cart');
        
        if (pageHasCollectionGrid) {
          setTimeout(function() {
            $formContainer.next().remove();
          });
        }
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
    // Mark load complete for any debounced callers
    isLoadingCart = false;
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart, timestamp: Date.now() },
        bubbles: true // lets you also listen on document in capture/bubble phases
      })
    );
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    blackFridayPromo(cart.total_price,cart);
    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
      .append('<div class="empty-msg"><h4>Your cart looks a little empty.</h4><p>Start your journey</p><div class="empty-cart-grid"><div><a href="https://www.sivanaspirit.com/collections/new-arrivals"><img src="//www.sivanaspirit.com/cdn/shop/files/New_Arrivals.png?v=1723750527"><p>New Arrivals</p></a></div><div><a href="https://www.sivanaspirit.com/collections/best-sellers"><img src="//www.sivanaspirit.com/cdn/shop/files/Best_Sellers.png?v=1723750613"><p>Best Sellers</p></a></div><div><a href="https://www.sivanaspirit.com/collections/women-tops/Material_bamboo"><img src="//www.sivanaspirit.com/cdn/shop/files/Bamboo_Tops.png?v=1723750644"><p>Bamboo Tops</p></a></div><div><a href="https://www.sivanaspirit.com/collections/women-pants/material_bamboo"><img src="//www.sivanaspirit.com/cdn/shop/files/Bamboo_Bottoms.png?v=1723750677"><p>Bamboo Bottoms</p></a></div></div></div>').addClass("empty");
      cartCallback(cart);
      return;
    }else{
      $cartContainer.removeClass("empty");     
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    var compareAtSubtotalCents = 0;
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      var compareprice = 0;
      var varID = cartItem.variant_id;

      $.ajax({ 
        url: '/products/' + cartItem.handle + '.js', 
        dataType: 'json',
        async: false, 
        success: function(product){ 

        // Define final sale tags to check
        const finalSaleTags = ['Badge_Final Sale', 'final-sale', 'final sale'];

        // Add a flag on BOTH product and cartItem JSON
        const isFinalSale = product.tags.some(tag => finalSaleTags.includes(tag));
        cartItem["is_final_sale"] = isFinalSale;

          product["compare_at_price"] = 0;
          product.variants.forEach(function(variant) {
            //console.log(variant.compare_at_price);
            
            if ( variant.id == varID && variant.compare_at_price !== 0){
              compareprice = variant.compare_at_price;
              return false;  

              //console.log('found a compare_at_price');
            }
          });
        }
      });

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_250x$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // show compare price?
      var showComparePrice = false;
      var showNormalComparePrice = false;
      if ( cartItem.original_line_price !== cartItem.line_price){
        showComparePrice = true;
      } else {
        if (compareprice > 0){
          showNormalComparePrice = true;
          compareAtSubtotalCents += compareprice * cartItem.quantity;
        } else {
          compareAtSubtotalCents += cartItem.original_line_price;
        }
      }

      

      var discountMessage = false;
      if(cartItem.discounts.length > 0){
        discountMessage = cartItem.discounts[0].title;
      }

      var preorderFromStoqApp = false;
      if (typeof cartItem.selling_plan_allocation !== 'undefined') {
        if(cartItem.selling_plan_allocation.selling_plan.name && cartItem.selling_plan_allocation.selling_plan.name == 'Preorder'){
          preorderFromStoqApp = true;
        }
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        original_line_price: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discountedPrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        NormalComparePrice: Shopify.formatMoney(compareprice, settings.moneyFormat),
        showComparePrice: showComparePrice,
        showNormalComparePrice: showNormalComparePrice,
        vendor: cartItem.vendor,
        discount_msg: discountMessage,
        final_sale: cartItem.properties !== null && cartItem.properties['_final-sale'] !== undefined,
        final_saletag: cartItem.is_final_sale,
        preorder: cartItem.properties !== null && cartItem.properties['Pre-order'] !== undefined, 
        preorderStoq: preorderFromStoqApp
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      // Total of all variant.compare_at_price (sum, in money format)
      totalCompareAt: (compareAtSubtotalCents > 0 && compareAtSubtotalCents > cart.total_price)
        ? Shopify.formatMoney(compareAtSubtotalCents, settings.moneyFormat)
        : null
    };


    $cartContainer.append(template(data));

    cartCallback(cart);
    //freeShip(cart.total_price, false);
    blackFridayPromo(cart.total_price, cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    // Ensure loading flag is cleared when rendering completes
    isLoadingCart = false;
    $body.trigger('ajaxCart.afterCartLoad', cart);
    
     if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }   
    
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
    
    
    //Remve item from cart
    $body.on('click', '.ajaxcart-remove-item', function() {
      var line = $(this).prev().find(".ajaxcart__qty--minus").attr("data-line");
      updateQuantity(line, 0);
    });
    

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Provide immediate header updates
    updateCountPrice(cart);

    // Centralized/debounced cart refresh and event dispatch
    setTimeout(function() { loadCart(); }, 150);
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var qtyNum  = parseInt(currentQty, 10) || 1,
            itemAdd = qtyNum + 1,
            itemMinus = Math.max(qtyNum - 1, 0),
            itemQty = qtyNum;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var qtyNum  = parseInt(currentQty, 10) || 1,
            itemAdd = qtyNum + 1,
            itemMinus = Math.max(qtyNum - 1, 1),
            itemQty = qtyNum;


        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };
  
  

  return module;

})(ajaxCart || {}, jQuery);
